module.exports = __webpack_public_path__ + "static/media/not_found.da9a12cc.png";